import React from "react";
import { formatDateWithoutTime } from "../../utils/formateDate";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const LegCarries = ({ carry }) => {
    const { t } = useTranslation();
    return (
        <>
            <div className="col-md-6">
                <div className="joinings_viewBox" style={{ minHeight: "unset" }}>
                    <div className="joinings_viewBox_head mb-3">
                        <h5>{t("binaryCommission")}</h5>
                    </div>
                    <div className="row">
                        <div className="col-md-6 text-center">
                            <h6>{t("totalLeftCarry")}</h6>
                            <p className="rightSide_top_user_dropdown_package">{carry?.totalLeft??0}</p>
                        </div>
                        <div className="col-md-6 text-center">
                            <h6>{t("totalRightCarry")}</h6>
                            <p className="rightSide_top_user_dropdown_package">{carry?.totalRight??0}</p>
                        </div>

                    </div>

                </div>
            </div>
            <div className="col-md-6">
                <div className="joinings_viewBox " style={{ minHeight: "unset" }}>
                    <div className="joinings_viewBox_head mb-3">
                        <h5>{t("repurchaseBinaryCommission")}</h5>
                    </div>

                    <div className="row">
                        <div className="col-md-6 text-center">
                            <h6>{t("repurchaseLeftCarry")}</h6>
                            <p className="rightSide_top_user_dropdown_package">{carry?.totalRepurchaseLeft??0}</p>
                        </div>
                        <div className="col-md-6 text-center">
                            <h6>{t("repurchaseRightCarry")}</h6>

                            <p className="rightSide_top_user_dropdown_package">{carry?.totalRepurchaseRight??0}</p>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default LegCarries;
